import { AGE_RANGE } from '~/constants/funnel/travel-insurance'

export function classifyTravellerAge (age) {
  const str = String(age ?? '').trim()

  if (!/^\d+$/.test(str)) {
    return null
  }

  const value = Number(str)

  if (value >= AGE_RANGE.adult[0] && value <= AGE_RANGE.adult[1]) {
    return 'adult'
  }

  if (value >= AGE_RANGE.dependant[0] && value <= AGE_RANGE.dependant[1]) {
    return 'dependant'
  }

  return null
}

export function parseAgesToTravellers (adultAges, dependantAges) {
  const toAges = value => String(value ?? '')
    .split(',')
    .map(age => age.trim())
    .filter(age => age !== '')

  const travellers = [...toAges(adultAges), ...toAges(dependantAges)]
    .map(age => ({ age }))

  return travellers.length ? travellers : [{ age: '' }]
}

export function travellersToAgeStrings (travellers) {
  const bands = { adult: [], dependant: [] }

  travellers.forEach(({ age }) => {
    const band = classifyTravellerAge(age)

    if (band) {
      bands[band].push(String(age).trim())
    }
  })

  return {
    adultAges: bands.adult.length ? bands.adult.join(', ') : null,
    dependantAges: bands.dependant.length ? bands.dependant.join(', ') : null
  }
}

export function summariseTravellers (travellers) {
  const counts = { adult: 0, dependant: 0 }

  travellers.forEach(({ age }) => {
    const band = classifyTravellerAge(age)

    if (band) {
      counts[band] += 1
    }
  })

  return [
    counts.adult ? `${counts.adult} adult${counts.adult > 1 ? 's' : ''}` : '',
    counts.dependant ? `${counts.dependant} dependant${counts.dependant > 1 ? 's' : ''}` : ''
  ].filter(Boolean).join(' · ')
}
